var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    clipPath: "url(#clip0_3909_13620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 1.4969C8.62734 1.34642 8.78485 1.22393 8.96251 1.13724C9.14016 1.05055 9.33405 1.00157 9.53182 0.993408C9.72959 0.985247 9.92691 1.01809 10.1112 1.08984C10.2955 1.1616 10.4627 1.27069 10.6022 1.41016C10.7416 1.54963 10.8503 1.71643 10.9213 1.89992C10.9922 2.08341 11.0239 2.27957 11.0143 2.47589C11.0047 2.67221 10.954 2.86439 10.8654 3.04018C10.7769 3.21597 10.6524 3.37152 10.5 3.4969L3.75 10.2469L1 10.9969L1.75 8.2469L8.5 1.4969Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 2.5L9.5 4.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3909_13620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.636cf0993b6b09aa7289abb4fd74fb3b.svg";
export { ForwardRef as ReactComponent };